var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin_1_",
    "data-name": "linkedin (1)",
    d: "M30,0A30,30,0,1,0,60,30,30,30,0,0,0,30,0ZM21.282,45.352H13.976V23.37h7.306ZM17.629,20.369h-.048a3.808,3.808,0,1,1,.1-7.6,3.81,3.81,0,1,1-.049,7.6Zm30,24.983H40.322V33.592c0-2.955-1.058-4.971-3.7-4.971a4,4,0,0,0-3.749,2.672,5,5,0,0,0-.24,1.783V45.352H25.326s.1-19.919,0-21.981h7.306v3.112a7.253,7.253,0,0,1,6.584-3.628c4.807,0,8.411,3.142,8.411,9.893Zm0,0",
    fill: "#90c900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLight);
export default __webpack_public_path__ + "static/media/linkedinLight.79a85a3eecca585be832ce53bf7c1c29.svg";
export { ForwardRef as ReactComponent };